import { actionTypes } from './actionTypes'
import { FILTER_TYPES } from './_helpers'
import { fromUtcString } from 'utils/dateUtilities'

const deserializeColumns = (json) => {
  const column = JSON.parse(json)
  if (column.type === FILTER_TYPES.date) { column.value = fromUtcString(column.value) }
  return column
}

export const actionCreators = (prefix) => ({
  load: (id) => (dispatch, getState) => {
    const x = getState().staticFilters.entity.find(x => x.id === id)
    const columns = (x ? x.columns : [])
    const title = (x ? x.title : '')
    const order = (x ? x.order : 0)
    const deserializedColumns = columns.map(x => deserializeColumns(x.json))
    dispatch({ type: actionTypes(prefix).load, payload: { columns: deserializedColumns, title, id, order } })
    dispatch(actionCreators(prefix).applyFilter(deserializedColumns))
  },
  addColumn: (id) => ({
    type: actionTypes(prefix).addColumn,
    payload: id
  }),
  removeColumn: (index) => ({
    type: actionTypes(prefix).removeColumn,
    payload: index
  }),
  updateColumn: (payload) => ({
    type: actionTypes(prefix).updateColumn,
    payload
  }),
  update: (payload) => ({
    type: actionTypes(prefix).update,
    payload
  }),
  applyFilter: (columns) => ({
    type: actionTypes(prefix).applyFilter,
    payload: columns
  }),
  clearFilters: () => ({
    type: actionTypes(prefix).clearFilters
  })
})